import axios from "axios"

export default {
    addFeedback(feedback) {
        return axios.post(window.API_BASE + '/api/v1/Feedback', feedback);
    }
}